module.exports = __webpack_public_path__ + "static/media/Home Page_website-14.b133e9cb.png";